import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	OnInit,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LeaderUserService } from '@services/leader';
import { LanguageService } from '@services/public';

const PAGE_PATH = `pages.leader.dashboard.groupManagement.stepTwo`;

@Component({
	selector: 'app-step-two',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './step-two.component.html',
})
export class StepTwoComponent implements OnInit, OnChanges {
	@Input() stepNext: any;
	public stepTwoForm: UntypedFormGroup;
	searchText = new UntypedFormControl('');
	masterSelected: boolean;
	checkedList: any = [];
	memberData: any = [];
	// Page language.
	page: { [key: string]: string } = {};
	constructor(
		private _languageSvc: LanguageService,
		private _userSvc: LeaderUserService,
	) {
		this.masterSelected = false;
	}

	ngOnChanges() {
		if (this.stepNext) {
			this._userSvc.getUsers().subscribe((users) => {
				this.memberData = users;
				this.memberData.map((ele) => {
					ele.checked = false;
				});
				let organizationUUID = JSON.parse(
					localStorage.getItem('groupOrganizationUUID'),
				);
				this.memberData = this.memberData.filter(
					(user: any) => user.organizationUUID === organizationUUID,
				);
				this.members = this.memberData;
			});
		}
	}
	selection = [];
	members: any = [];

	ngOnInit(): void {
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page)
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
		});
	}

	searchKey(data: string) {
		this.search();
	}
	search() {
		this.members =
			this.searchText.value === ''
				? this.memberData
				: this.memberData.filter(
						(val) =>
							val.name
								.toLowerCase()
								.indexOf(this.searchText.value.toLowerCase()) >= 0,
					);
		if (this.members.length !== 0) {
			this.masterSelected = this.members.every(function (item: any) {
				return item.checked == true;
			});
		}
	}

	checkUncheckAll() {
		for (var i = 0; i < this.members.length; i++) {
			this.members[i].checked = this.masterSelected;
		}
		this.getCheckedItemList();
	}

	// Check All Checkbox Checked
	isAllSelected() {
		this.masterSelected = this.members.every(function (item: any) {
			return item.checked == true;
		});
		this.getCheckedItemList();
	}

	// Get List of Checked Items
	getCheckedItemList() {
		this.checkedList = [];
		for (var i = 0; i < this.members.length; i++) {
			if (this.members[i].checked) this.checkedList.push(this.members[i].uuid);
		}
	}

	stepTwoSubmit() {
		let groupDetails = JSON.parse(localStorage.getItem('groupDetails'));
		if (this.checkedList.length !== 0) {
			groupDetails.members = this.checkedList;
		} else {
			groupDetails.members = [];
		}
		localStorage.setItem('groupDetails', JSON.stringify(groupDetails));
	}

	clearLocalVaule() {}
}
